import React, { useEffect, useState } from "react";

import Select from "react-select";

import ReactDatetime from "react-datetime";

import jsPDF from "jspdf";
import moment from "moment";
import NotificationAlert from "react-notification-alert";

import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
  Modal,
  ModalBody
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableContainer from "@mui/material/TableContainer";

import Paper from "@mui/material/Paper";

import { withRouter } from "react-router-dom";

import axios from "axios";
import {
  CHANNEL_CLIENT_CHNLTYPE,
  DAYWISE_WHATSAPP_REPORTS,
  DAYWISE_WHATSAPP_REPORTS_EXCELL,
  WHATSAPP_ALL_TEMPLATES,
  WHATSAPP_USER_RESPONSE
} from "../../constants.js";
import apiService from "../../variables/apiService.js";

import * as FileSaver from "file-saver";
import autoTable from "jspdf-autotable";
import LoadingScreen from "react-loading-screen";
import * as XLSX from "xlsx";
//import logo from "../../../assets/img/logo.png";
import logo from "../../assets/img/logo.png";
import { ModalFooter } from "react-bootstrap";

let templates = [];
let senderids = [];
const localJson = localStorage.getItem("user");
const user= JSON.parse(localJson)
const Daywisereports = (props) => {
  const [singleSelect, setsingleSelect] = useState( { value: 0, label: "Select All" });
 
  const [daywiseList, setDaywiseList] = useState([]);
  const [daywiseListCln, setDaywiseListCln] = useState([]);
  const [drpdwn,setDrpdwn] = useState([{ value: 0, label: "Select Template" }]);
  const [whatsappdetailLst, setWhatsappdetailLst] = useState(null);
  const [whatsappdetailLstC, setWhatsappdetailLstC] = useState(null);

  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle,setErrorHandle]= useState()
  const notificationAlertRef = React.useRef(null);
  const [countModal,setCountModal] = useState(false)
  const drpdwns=[
    { value: 0, label: "Select All" },                   
    { value: 1, label: "Utility" },
    { value: 2, label: "Template" },
   
  ]

  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    templateid:"",
    campaignname:"",
    senderid:""
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const [channel, setChannel] = useState([]);
  const [dstatus,setStatus] = useState("")
  const [detaileddate,setdetaileddate] = useState("")

  

  const [currentPage, setCurrentPage] = useState(1);
 

  const filteruser = (val) => {
    const filterobj = daywiseListCln?.message?.filter((item) =>
      item.Date.includes(val.toLowerCase())
    );
    setDaywiseList({
      message: filterobj,
    });
  };

  const fetchChanelsbyClient=()=>{
    
    setIsLoading(true)

    const payload={
      channels_type:"whatsapp",
      clintId:user?.client
    }  
    
     axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      templates=[]
     
      setChannel( res?.data)
    

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template },)
        
      })
      
      setIsLoading(false)
     }).catch(e=>{
      setIsLoading(false)
      let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    })

  }

  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
 

    setSearch(prev=>({...prev,templateid:data,senderid:""}))
  }
  const submitHandler = async () => {
   

    const isValid=validatedate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);
    var payload={}
    if(singleSelect.value==2){
       payload={
        fromdate:fromdate,
        todate: todate ,
        senderid:search?.senderid?.value,
        template:search?.templateid?.value,
        type:singleSelect.value,
        client_id:user.client,
      }
    }else if(singleSelect.value==1){
       payload={
        fromdate:fromdate,
        todate: todate ,
        client_id:user.client,
        type:singleSelect.value
      }
    }else{
      payload={
        fromdate:fromdate,
        todate: todate ,
        client_id:user.client,
        type:singleSelect.value,
        senderid:user.sender_id,
      }
    }
  
    setIsLoading(true)
    await apiService
      .postData(
        DAYWISE_WHATSAPP_REPORTS ,payload
       
      )
      .then((res) => {
        setDaywiseList(res.data);
        setDaywiseListCln(res.data);
        setIsLoading(false)
      })
      .catch((err) =>{
        let options = {};
        options = {
          place: "tr",
          message: err?.message,
          type: "warning",
          autoDismiss: 3,
        };
        setDaywiseList([]);
        notificationAlertRef?.current?.notificationAlert(options);
        setIsLoading(false);
        console.log("error====>", err.message)
      })
    }
  };
  const validatedate=()=>{
    let errors={}
    if(!search.fromdate){
      errors.fromdate="Please Select From Date"
    }  if(!search?.todate){
      errors.todate="Please Select To Date"
    }
    if( singleSelect?.value==2){
       if(!search?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!search?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    }
   
    return errors;
   }
  const generateEXCEL = async (date,type) => {
   setIsLoading(true)
   let fromdate = moment(date).format("YYYY-MM-DD");
   let todate = moment(date).format("YYYY-MM-DD");
  

   let lclstrg = localStorage.getItem("user");
   let user = JSON.parse(lclstrg);
   let payload={
     fromdate:fromdate,
     todate: todate ,
     senderid:search?.senderid?.value||user.sender_id,
     template:search?.templateid?.value,
     type:singleSelect.value,
     client_id:user.client,
     
   }
      await apiService
      .postData(
        DAYWISE_WHATSAPP_REPORTS_EXCELL ,payload
       
      )
        .then((res) => {
          setIsLoading(false)
          const body =
            res.data.message.length > 0 ? res.data.message : "No Records";
          if (type === 1) {
            const fileType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

            const fileExtension = ".xlsx";
            const ws = XLSX?.utils?.json_to_sheet(body);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, {
              bookType: "xlsx",
              type: "array",
            });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "Daywise Detailed Report "+todate + fileExtension);
          } else {
            var rows = [];

            for (let i = 0; i < body.length; i++) {
              var temp = [
                i + 1,
                body[i].Date,
                body[i].TotalRequestssent,
                body[i].TotalDelivered,
                body[i].TotalRead,
                0,
                body[i].TotalTextMessageSent,
                body[i].TotalTextTelivered,
                body[i].TotalTextread,
              ];
              rows.push(temp);
            }

            const doc = new jsPDF("p", "pt");

            autoTable(doc, { html: "#my-table" });
            doc.text(115, 40, `${fromdate} __ ${todate} Daywise Report`);
            autoTable(doc, {
              head: [
                [
                  "S NO",
                  "DATE",
                  "NOTIFICATION SENT",
                  "NOTIFICATION DELIVERY",
                  "NOTIFICATION READ",
                  "NOTIFICATION COST",
                  "TEXT MESSAGE SENT",
                  "TEXT MESSAGE DELIVERY",
                  "TEXT MESSAGE READ",
                ],
              ],
              body: rows,
            });

            doc.save(todate + ".pdf");
          }
        })
        .catch((err) =>{
          let options = {};
          options = {
            place: "tr",
            message: err?.message,
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef?.current?.notificationAlert(options);
          setIsLoading(false);
          console.log("error====>", err.message)
        })
    
  };


  const generateEXCELMonthly = async () => {
   setIsLoading(true)

  
   let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);
    let payload={
      fromdate:fromdate,
      todate: todate ,
      senderid:search?.senderid?.value||user?.sender_id,
      template:search?.templateid?.value,
      type:singleSelect.value,
      client_id:user.client,
    }
     
       await apiService
       .postData(
        DAYWISE_WHATSAPP_REPORTS ,payload
        
       )
         .then((res) => {
          setIsLoading(false)
           const body =
             res.data.message.length > 0 ? res.data.message : "No Records";
            if(res.data.message.length > 0 ){

             const fileType =
               "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
 
             const fileExtension = ".xlsx";
             const ws = XLSX.utils.json_to_sheet(body);
             const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
             const excelBuffer = XLSX.write(wb, {
               bookType: "xlsx",
               type: "array",
             });
             const data = new Blob([excelBuffer], { type: fileType });
             FileSaver.saveAs(data, "Count Report "+todate + fileExtension);
         
            }
         })
         .catch((err) =>{
          let options = {};
          options = {
            place: "tr",
            message: err?.message,
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef?.current?.notificationAlert(options);
          setIsLoading(false);
          console.log("error====>", err.message)
        })
     
   };

   const generateEXCELMonthlyDetail = async () => {
    setIsLoading(true)
     
        let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
        let todate = moment(search.todate).format("YYYY-MM-DD");
        let lclstrg = localStorage.getItem("user");
        let user = JSON.parse(lclstrg);
        let payload={
          fromdate:fromdate,
          todate: todate ,
          senderid:search?.senderid?.value||user.sender_id,
          client_id:user.client,
         
        }
        await apiService
        .postData(
         WHATSAPP_ALL_TEMPLATES ,payload
         
        )
          .then((res) => {
           setIsLoading(false)
            const body =
              res.data.message.length > 0 ? res.data.message : "No Records";
          if( res.data.message.length > 0){
            const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(body);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "Detailed Report "+todate + fileExtension);
          }
            
          
          })
          .catch((err) =>{
            setIsLoading(false)
            let options = {};
            options = {
              place: "tr",
              message: err?.message,
              type: "warning",
              autoDismiss: 3,
            };
            notificationAlertRef?.current?.notificationAlert(options);
            console.log("error====>", err)
          } );
      
    };

  const toDatevalidation = (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };

  const changeSelect=(data)=>{
   
    setsingleSelect(data)
    if(data.value==1){
      setSearch({...search,template:""})
    }else  if(data.value==2){
      fetchChanelsbyClient();
    }
  }
  var valid = function( current ){
    var yesterday = moment().subtract( 0, 'day' );
  
        return current.isBefore( yesterday );
    };

  const detailedreport=(page,status,date)=>{
      const lclStrge = localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      let fromdate = date;
      let todate =date;
      const sender_id = user?.sender_id;
      const type = "Outbound";
      const advfltkey = "status";
      const advfltrval = status;
      setIsLoading(true)
      setCurrentPage(page);

      apiService
      // .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search?.campaignname}&template=${search?.templateid?.value}&mobile=${search.mobile}&senderid=${search?.senderid?.value}&page=` + page)
      .getData(
        WHATSAPP_USER_RESPONSE +
          `?fromdate=${fromdate}&todate=${todate}&senderid=${sender_id}&page=${page}&type=${type}&advfltkey=${advfltkey}&advfltval=${advfltrval}`
      )

      .then((res) => {
        setWhatsappdetailLst(res?.data);
        setWhatsappdetailLstC(res?.data);
        setCountModal(true)
        setIsLoading(false);
       
      })
      .catch((err) => {
        console.log("error===>", err);
        setCurrentPage(1)
        setIsLoading(false);
      });

  }
  return (
    <>
      <div className="content pb-0" >
        <Row>
          <Col md="12">
          <Modal isOpen={countModal} toggle={()=>setCountModal(false)} className="detailedReport" >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={()=>{setCountModal(false);setCurrentPage(1)}}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <p className="title title-up">{dstatus} Records</p>
            </div>
            <ModalBody className="modelbody ">
              <Row >

              <Table responsive stiped style={{height:"450px !important"}}>
                    <thead>
                      <tr>
                      <th>Sno </th>
                        <th> Date</th>
                        <th> Code </th>
                        <th> Mobile No</th>
                        <th> MsgId</th>
                        <th> Direction </th>
                        <th> Type </th>
                        <th> Content</th>
                        <th> Id</th>
                        <th> Name</th>
                        <th> Status</th>
                       {dstatus=="failed"&&<th> Error</th>} 

                       
                      </tr>
                    </thead>
                    <tbody>
                    {whatsappdetailLst?.message?.length > 0 ? (
                        whatsappdetailLst?.message?.map((item, index) => {
                          let templateid = "";
                          let content ="";
                          if (item.ID === "whatsapp_file_pull") {
                            templateid = "1709";
                          } else if (item.ID === "whatsapp_file_recall") {
                            templateid = "1708";
                          } else if (
                            item.ID === "whatsapp_file_cancel_check_1"
                          ) {
                            templateid = "1816";
                          } else if (
                            item.ID === "whatsapp_file_dismiss_check_1"
                          ) {
                            templateid = "1814";
                          } else if (
                            item.ID === "whatsapp_file_return_check_1"
                          ) {
                            templateid = "1818";
                          } else if (item.ID === "whatsappsharetemplate") {
                            templateid = "1802";
                          } else if (item.ID === "whatsapptask_received") {
                            templateid = "1812";
                          }
                          else if (item.ID === "OTP") {
                            templateid = "1706";
                          }
                          const Contenttrim = item.Content.trim();
                         
                          const contntJson =
                          (Contenttrim.startsWith('{') && Contenttrim.endsWith('}')) ||
                          (Contenttrim.startsWith('[') && Contenttrim.endsWith(']'));
                         if(contntJson){
                          const tempcont = JSON.parse(item.Content);
                          content = JSON.stringify(tempcont?.template?.components);
                         }else{
                          content = item.Content;
                         }
                         
                          return (
                            <>
                              <tr>
                                <td >{index + 1}</td>
                                <td>
                                  {moment(item.CreatedDate).format(
                                    "YYYY-MM-DD H:m"
                                  )}
                                </td>
                                <td>{item?.Code}</td>
                                <td >{item.msisdn}</td>
                                <td>{item.msgid}</td>
                                <td>{item.Direction}</td>
                                <td>{(item.ID=="1706"?"OTP":item.ID) || "NA"}</td>
                                <td>{content}</td>
                                <td>{templateid==""?item.ID:templateid}</td>
                                <td>{item?.name || "NA"}</td>
                                <td>{item.status}</td>
                                {dstatus=="failed"&&<td> {item.error_title}</td>} 
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="13">No Records Availble</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                
               
              </Row>
            </ModalBody>
            <ModalFooter>
            {whatsappdetailLst?.numOfPages > 0 && (
                <div style={{ width: "30%", marginLeft: "auto" }}>
                  <ResponsivePagination
                    current={currentPage}
                    total={whatsappdetailLst?.numOfPages}
                    onPageChange={(newPage) => {
                      detailedreport(newPage,dstatus,detaileddate);
                    }}
                  />
                </div>
              )}
            </ModalFooter>
          </Modal>
            <Card className="mb-2">
              <CardBody>
             
              <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                        setCurrentPage(1)
                      }}
                      isValidDate={ valid }
                    />
                    <span style={{color:"red"}}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                        setCurrentPage(1)
                      }}
                      isValidDate={ valid }
                      // onChange={(val) =>{setSearch({...search,todate:val._d});setValidate({
                      //   message:"",
                      //   notValid:false
                      // } )}}
                    />
                   <span style={{color:"red"}}>{errorhandle?.todate}</span>
                  </Col>

                  <Col md="2" sm='12'>
                    <p className="category">Select </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => {
                            changeSelect(value);
                            }}
                          options={drpdwns}
                          placeholder="Select"
                        />
                    </Col>
                    
                   { 
                   singleSelect?.value==2&&
                    <>
                      <Col md="4" sm="12">
                      <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="templateSelect"
                        value={search.templateid}
                        onChange={(value) => changeSender(value)}
                        options={templates}
                        placeholder="Select"
                      />
                      {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
                    </Col>
                    <Col md="4" sm="12">
                      <p className="category">Select Sender<suf style={{color:"red"}}>*</suf> </p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderSelect"
                        value={search?.senderid}
                        onChange={(value) => setSearch({...search,senderid:value})}
                        options={senderids}
                        placeholder="Select"
                      />
                       {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
                    </Col>
                    </>
                    }

                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler()}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                   
                    <Button
                      className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() => generateEXCELMonthly()}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipexcel"
                    >
                      Count Report
                    </UncontrolledTooltip>
                   </Col>
                   <Col md="2" sm="12" style={{marginLeft:"auto"}}>
                   
                    <Button 
                      className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                      color="primary"
                      data-placement="top"
                      id="tooltippdf1"
                      type="button"
                      //disabled="true"
                      onClick={() => generateEXCELMonthlyDetail()}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                      
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltippdf1"
                    >
                      Detailed Report
                    </UncontrolledTooltip>
                   
                   
                  </Col>

                 
              
                </Row>
                <Row>
                  
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
              <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
                <TableContainer component={Paper}  className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th rowspan="2">S no </th>
                        <th rowspan="2"> Date</th>
                        {/* <th>Submitted </th> */}
                        <th>Sent </th>
                        <th> Delivery</th>
                        <th> Read </th>
                        <th> Fail </th>
                        <th> Chat_Ses </th>
                        <th> Action </th>
                      
                      </tr>
                     
                    </thead>
                    <tbody>
                 
                      {daywiseList?.message?.length > 0 ? (
                        daywiseList?.message?.map((row, index) => (
                          <tr
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td>{index + 1}</td>
                            <td> {moment(row.date).format("YYYY-MM-DD")}</td>
                           
                            <td>{row.sent}  </td>
                            {/* <td>{row.sent}</td> */}
                            <td>{row.deliver}</td>
                            <td  onClick={()=>{setdetaileddate(moment(row.date).format("YYYY-MM-DD"));setStatus("read");detailedreport(currentPage,"read",moment(row.date).format("YYYY-MM-DD"))}}>{row.readby}  <i className="tim-icons icon-tap-02" /></td>
                            <td onClick={()=>{setdetaileddate(moment(row.date).format("YYYY-MM-DD"));setStatus("failed");detailedreport(currentPage,"failed",moment(row.date).format("YYYY-MM-DD"))}}>{row.failed} <i className="tim-icons icon-tap-02" /></td>
                            <td>{row.chat_ses}</td>
                            <td><span
                     
                      color="primary"
                      data-placement="top"
                      
                      type="button"
                      onClick={() => generateEXCEL(row.date,1)}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </span></td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <td colSpan={9}>No Records</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
              {/* <Row>
              <Col md="12" >
          <Pagination  className='pull-right'>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Previous"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-left"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Next"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-right"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
          </Col>
              </Row> */}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(Daywisereports);
